<template>
  <form @submit.prevent="submit">
    <fg-input label="Name"
      type="text"
      v-model="unit.name"
      :error="valErrors['name'] ? valErrors['name'][0] : null"
    />
    <button type="submit" class="btn btn-fill btn-info">{{ submitText }}</button>
  </form>
</template>

<script>
export default {
  props: ['valErrors', 'initUnit', 'submitText'],
  data () {
    return {
      unit: this.initUnit
    }
  },
  methods: {
    submit () {
      this.$emit('submit', this.unit)
    }
  }
}
</script>

<style>
</style>
